import { combineReducers } from 'redux';
import storageSession from 'redux-persist/lib/storage/session'
import localSession from 'redux-persist/lib/storage';
import customerComments from '../../component/screens/customerComments/customerCommentsReducer'
import loading from '../../component/containers/loader/LoaderReducer'
import ServiceErrorReducer from '../../common/ServiceError/ServiceErrorReducer';
import accessDetails from './accessDetailsReducer';

const rootReducer = combineReducers({
    loading: loading,
    customerComments: customerComments,
    serviceError: ServiceErrorReducer,
    accessDetails: accessDetails
});


const appReducer = (state, action) => {
    if (action.type === 'CLEAR_STORE') {
        storageSession.removeItem(`persist:CTL`);
        localSession.removeItem(`persist:CTL`);
       
        state = undefined
    }
    if (action.type === 'CLEAR_CUSTOMERCOMMENTS') {
        state = { ...state, customerComments: undefined }
    }
    if (action.type === 'CLEAR_SERVICEERROR') {
        state = { ...state, serviceError: undefined }
    }
    // if (action.type === 'CTLWEBFORM') {
    //     state = { ...state, ctlWebForm: undefined }
    // }
    
    if (action.type === 'CLEAR_ALL') {
        state = undefined
    }
    return rootReducer(state, action)
}
export default appReducer;